export default "__VITE_ASSET__19f67888__"